import { IHttpError, useCompanyCreateNoteContractMutation } from '@/@data'
import DialogCloseButton from '@/components/dialog/DialogCloseButton'
import { useNotification } from '@/hooks/useNotification'
import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material'
import TextArea from 'antd/es/input/TextArea'
import { Controller, FormProvider, useForm } from 'react-hook-form'

interface EmployerAddNoteProps {
  open: boolean
  onClose: () => void
  refetch: () => void
}

export const EmployerAddNote = ({
  open,
  onClose,
  refetch }: EmployerAddNoteProps) => {
  const { __ } = useTranslator()
  const n = useNotification()
  const { id } = useParams()

  const { mutate: createNoteContract } = useCompanyCreateNoteContractMutation()

  useEffect(() => {
    if (open) {
      methods.reset({
        note: ''
      })
    }
  }, [open])

  const methods = useForm<any>({
    defaultValues: {
      note: ''
    },
    mode: 'onChange'
  })

  const onSubmit = (data: any) => {
    createNoteContract(
      {
        data: { note: data.note },
        companyId: Number(id)
      },
      {
        onSuccess: () => {
          n.success(__('Add note successfully'))
          onClose()
          refetch()
        },
        onError: (error: IHttpError) => {
          n.error(error.message)
        }
      }
    )
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      scroll='body'
      fullWidth
      closeAfterTransition={false}
      sx={{
        '& .MuiDialog-paper': { overflow: 'visible', maxWidth: '700px', borderRadius: '32px' }
      }}
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <DialogContent className='p-0 m-0' sx={{ padding: 0 }}>
            <DialogCloseButton onClick={onClose} disableRipple>
              <i className='tabler-x' />
            </DialogCloseButton>
            <Box className='flex flex-col gap-6 p-6'>
              <Typography className='text-[18px] leading-[28px] font-medium text-[#2f2b3de6]'>{__('Note')}</Typography>
              <div className='flex flex-col gap-1'>
                <Typography className='text-[13px] leading-[20px] font-normal text-[#2F2B3D]'>
                  {__('Your Note')}
                </Typography>
                <Controller
                  control={methods.control}
                  name='note'
                  render={({ field }) => <TextArea placeholder={__('Note')} rows={7} className='w-full rounded-lg' {...field} />}
                />
              </div>
            </Box>
          </DialogContent>
          <DialogActions className='flex justify-end gap-3 px-6 pb-6'>
            <Button type='submit' variant='contained' className='bg-[#3551F2] text-[#fff] rounded-full'>
              <span className='text-[15px] font-medium'>
                {__('Submit')}
              </span>
            </Button>
            <Button variant='outlined' className='text-[#3551F2] rounded-full ml-0' onClick={onClose}>
              <span className='text-[15px] font-medium'>
                {__('Cancel')}
              </span>
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  )
}
